const DEFAULT_VALUE = '16px'

export const handleChangeFontSize = (value = DEFAULT_VALUE) => {
  document.documentElement.style.setProperty('--font-size-base', value)
}
